/**
 * Formats a date object to MM/DD/YYYY string format
 * @param date - Date object to format
 * @returns Formatted date string in MM/DD/YYYY format
 */
export const formatDate = (date: Date | null): string => {
  if (!date) return "";
  return `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
    date.getDate()
  ).padStart(2, "0")}/${date.getFullYear()}`;
};

/**
 * Formats a date range to a single string in format MM/DD/YYYY-MM/DD/YYYY
 * @param startDate - Start date of the range
 * @param endDate - End date of the range
 * @returns Formatted date range string or empty string if both dates aren't provided
 */
export const formatDateRange = (startDate: Date | null, endDate: Date | null): string => {
  if (!startDate || !endDate) return "";
  return `${formatDate(startDate)}-${formatDate(endDate)}`;
};
